var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0234 5.83341H11.6901V7.50008H10.0234V5.83341ZM10.0234 9.16675H11.6901V14.1667H10.0234V9.16675ZM10.8568 1.66675C6.25677 1.66675 2.52344 5.40008 2.52344 10.0001C2.52344 14.6001 6.25677 18.3334 10.8568 18.3334C15.4568 18.3334 19.1901 14.6001 19.1901 10.0001C19.1901 5.40008 15.4568 1.66675 10.8568 1.66675ZM10.8568 16.6667C7.18177 16.6667 4.1901 13.6751 4.1901 10.0001C4.1901 6.32508 7.18177 3.33341 10.8568 3.33341C14.5318 3.33341 17.5234 6.32508 17.5234 10.0001C17.5234 13.6751 14.5318 16.6667 10.8568 16.6667Z",
    fill: "#33CC99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeInfo);
export default __webpack_public_path__ + "static/media/icone-info.ced4d46ff886013ee365052290a4768b.svg";
export { ForwardRef as ReactComponent };